const paintings2 = [
  {
    id: '2_01',
    name: 'Italianate Landscape With Travellers',
    imageSrc: 'level2/2_01.jpg',
    cutSrc: 'level2/cut/2_01.jpg',
    author: 'BARKER, Thomas',
    year: '1793',
  },
  {
    id: '2_02',
    name: 'Landscape with a Watermill',
    imageSrc: 'level2/2_02.jpg',
    cutSrc: 'level2/cut/2_02.jpg',
    author: 'BARRET, George',
    year: '1728',
  },
  {
    id: '2_03',
    name: 'Winter',
    imageSrc: 'level2/2_03.jpg',
    cutSrc: 'level2/cut/2_03.jpg',
    author: 'BASSANO, Francesco',
    year: '1577-78',
  },
  {
    id: '2_04',
    name: 'Skating at Sloten, near Amsterdam',
    imageSrc: 'level2/2_04.jpg',
    cutSrc: 'level2/cut/2_04.jpg',
    author: 'BEERSTRATEN, Jan Abrahamsz.',
    year: '1660-65',
  },
  {
    id: '2_05',
    name: 'The Castle of Batavia, Seen from Kali Besar West',
    imageSrc: 'level2/2_05.jpg',
    cutSrc: 'level2/cut/2_05.jpg',
    author: 'BEECKMAN, Andries',
    year: '1656',
  },
  {
    id: '2_06',
    name: 'The Hague Vegetable Market in Winter',
    imageSrc: 'level2/2_06.jpg',
    cutSrc: 'level2/cut/2_06.jpg',
    author: 'BEEST, Sybrand van',
    year: '1650',
  },
  {
    id: '2_07',
    name: 'Seashore',
    imageSrc: 'level2/2_07.jpg',
    cutSrc: 'level2/cut/2_07.jpg',
    author: 'BEGEYN, Abraham Jansz.',
    year: '1662',
  },
  {
    id: '2_08',
    name: 'Banks of the Oise',
    imageSrc: 'level2/2_08.jpg',
    cutSrc: 'level2/cut/2_08.jpg',
    author: 'BÉLIARD, Edouard',
    year: '1875',
  },
  {
    id: '2_09',
    name: 'View of the Grand Canal at San Stae',
    imageSrc: 'level2/2_09.jpg',
    cutSrc: 'level2/cut/2_09.jpg',
    author: 'BELLOTTO, Bernardo',
    year: '1738-40',
  },
  {
    id: '2_10',
    name: 'The Piazza della Signoria in Florence',
    imageSrc: 'level2/2_10.jpg',
    cutSrc: 'level2/cut/2_10.jpg',
    author: 'BELLOTTO, Bernardo',
    year: '1740',
  },
  {
    id: '2_11',
    name: 'View of the Villa Cagnola at Gazzada near Varese',
    imageSrc: 'level2/2_11.jpg',
    cutSrc: 'level2/cut/2_11.jpg',
    author: 'BELLOTTO, Bernardo',
    year: '1744',
  },
  {
    id: '2_12',
    name: 'The Campagna at Lungezza near Rome',
    imageSrc: 'level2/2_12.jpg',
    cutSrc: 'level2/cut/2_12.jpg',
    author: 'BENOUVILLE, Jean-Achille',
    year: '1848',
  },
  {
    id: '2_13',
    name: 'A Southern Harbour Scene',
    imageSrc: 'level2/2_13.jpg',
    cutSrc: 'level2/cut/2_13.jpg',
    author: 'BERCHEM, Nicolaes',
    year: '1657-59',
  },
  {
    id: '2_14',
    name: 'A Harbour Scene',
    imageSrc: 'level2/2_14.jpg',
    cutSrc: 'level2/cut/2_14.jpg',
    author: 'BERCHEM, Nicolaes',
    year: '1665-70',
  },
  {
    id: '2_15',
    name: 'The Invalides, Paris',
    imageSrc: 'level2/2_15.jpg',
    cutSrc: 'level2/cut/2_15.jpg',
    author: 'CANELLA, Giuseppe',
    year: '1830',
  },
  {
    id: '2_16',
    name: 'View of Ariccia with the Sea in the Background',
    imageSrc: 'level2/2_16.jpg',
    cutSrc: 'level2/cut/2_16.jpg',
    author: 'CATEL, Franz Ludwig',
    year: '1821-25',
  },
  {
    id: '2_17',
    name: 'The Miracles of the Penitent St Mary',
    imageSrc: 'level2/2_17.jpg',
    cutSrc: 'level2/cut/2_17.jpg',
    author: 'CHAMPAIGNE, Philippe de',
    year: '1656',
  },
  {
    id: '2_18',
    name: 'Autumn',
    imageSrc: 'level2/2_18.jpg',
    cutSrc: 'level2/cut/2_18.jpg',
    author: 'CHURCH, Frederic Edwin',
    year: '1875',
  },
  {
    id: '2_19',
    name: 'Landscape with Merchants',
    imageSrc: 'level2/2_19.jpg',
    cutSrc: 'level2/cut/2_19.jpg',
    author: 'CLAUDE LORRAIN',
    year: '1630',
  },
  {
    id: '2_20',
    name: 'Landscape with Shepherds',
    imageSrc: 'level2/2_20.jpg',
    cutSrc: 'level2/cut/2_20.jpg',
    author: 'CLAUDE LORRAIN',
    year: '1645-46',
  },
  {
    id: '2_21',
    name: 'The Hay-Wain',
    imageSrc: 'level2/2_21.jpg',
    cutSrc: 'level2/cut/2_21.jpg',
    author: 'CONSTABLE, John',
    year: '1821',
  },
  {
    id: '2_22',
    name: 'The Bridge at Mantes',
    imageSrc: 'level2/2_22.jpg',
    cutSrc: 'level2/cut//2_22.jpg',
    author: 'COROT, Jean-Baptiste Camille',
    year: '1868-70',
  },
  {
    id: '2_23',
    name: 'View of Frankfurt am Main',
    imageSrc: 'level2/2_23.jpg',
    cutSrc: 'level2/cut/2_23.jpg',
    author: 'COURBET, Gustave',
    year: '1858',
  },
  {
    id: '2_24',
    name: 'The Cliff at Étretat after the Storm',
    imageSrc: 'level2/2_24.jpg',
    cutSrc: 'level2/cut/2_24.jpg',
    author: 'COURBET, Gustave',
    year: '1869-70',
  },
  {
    id: '2_25',
    name: 'Greenwood Lake',
    imageSrc: 'level2/2_25.jpg',
    cutSrc: 'level2/cut/2_25.jpg',
    author: 'CROPSEY, Jasper Francis',
    year: '1870',
  },
  {
    id: '2_26',
    name: 'The Avenue at Meerdervoort',
    imageSrc: 'level2/2_26.jpg',
    cutSrc: 'level2/cut/2_26.jpg',
    author: 'CUYP, Aelbert',
    year: '1650-52',
  },
  {
    id: '2_27',
    name: 'The Valkhof at Nijmegen',
    imageSrc: 'level2/2_27.jpg',
    cutSrc: 'level2/cut/2_27.jpg',
    author: 'CUYP, Aelbert',
    year: '1652-54',
  },
  {
    id: '2_28',
    name: 'Morning after a Stormy Night',
    imageSrc: 'level2/2_28.jpg',
    cutSrc: 'level2/cut/2_28.jpg',
    author: 'DAHL, Johan Christian Clausen',
    year: '1819',
  },
  {
    id: '2_29',
    name: 'Eruption of the Vesuvius',
    imageSrc: 'level2/2_29.jpg',
    cutSrc: 'level2/cut/2_29.jpg',
    author: 'DAHL, Johan Christian Clausen',
    year: '1823',
  },
  {
    id: '2_30',
    name: 'Landscape with Shepherds',
    imageSrc: 'level2/2_30.jpg',
    cutSrc: 'level2/cut/2_30.jpg',
    author: 'DALEM, Cornelis van',
    year: '1550-60',
  },
  {
    id: '2_31',
    name: 'The Barges',
    imageSrc: 'level2/2_31.jpg',
    cutSrc: 'level2/cut/2_31.jpg',
    author: 'DAUBIGNY, Charles-François',
    year: '1865',
  },
  {
    id: '2_32',
    name: 'The Sea from the Heights of Dieppe',
    imageSrc: 'level2/2_32.jpg',
    cutSrc: 'level2/cut/2_32.jpg',
    author: 'DELACROIX, Eugène',
    year: '1852',
  },
  {
    id: '2_33',
    name: 'Architectural Capriccio with Jephthah and His Daughter',
    imageSrc: 'level2/2_33.jpg',
    cutSrc: 'level2/cut/2_33.jpg',
    author: 'DELEN, Dirck van',
    year: '1633',
  },
  {
    id: '2_34',
    name: 'The Pont Neuf and the Quai des Orfèvres, from the Place du Pont Neuf',
    imageSrc: 'level2/2_34.jpg',
    cutSrc: 'level2/cut/2_34.jpg',
    author: 'DELPY, Hippolyte-Camille',
    year: '1875',
  },
  {
    id: '2_35',
    name: 'Houses at a Millrace',
    imageSrc: 'level2/2_35.jpg',
    cutSrc: 'level2/cut/2_35.jpg',
    author: 'DEPPE, Ludwig',
    year: '1820',
  },
  {
    id: '2_36',
    name: 'The Forest in Fontainebleau',
    imageSrc: 'level2/2_36.jpg',
    cutSrc: 'level2/cut/2_36.jpg',
    author: 'DIAZ DE LA PEÑA, Narcisse Virgile',
    year: '1867',
  },
  {
    id: '2_37',
    name: 'View from the Giudecca, Venice',
    imageSrc: 'level2/2_37.jpg',
    cutSrc: 'level2/cut/2_37.jpg',
    author: 'DOMENICHINI, Apollonio',
    year: '1744',
  },
  {
    id: '2_38',
    name: 'Landscape with Ford',
    imageSrc: 'level2/2_38.jpg',
    cutSrc: 'level2/cut/2_38.jpg',
    author: 'DOMENICHINO',
    year: '1603',
  },
  {
    id: '2_39',
    name: 'Gorge',
    imageSrc: 'level2/2_39.jpg',
    cutSrc: 'level2/cut/2_39.jpg',
    author: 'DORÉ, Gustave',
    year: '1878',
  },
  {
    id: '2_40',
    name: 'Dolmen on Brandsø',
    imageSrc: 'level2/2_40.jpg',
    cutSrc: 'level2/cut/2_40.jpg',
    author: 'DREYER, Dankvart',
    year: '1842',
  },
  {
    id: '2_41',
    name: 'Village Scene',
    imageSrc: 'level2/2_41.jpg',
    cutSrc: 'level2/cut/2_41.jpg',
    author: 'DROOCHSLOOT, Joost Cornelisz.',
    year: '1623',
  },
];

export default paintings2;
